import { render, staticRenderFns } from "./ExamGroupShow.vue?vue&type=template&id=16980073&scoped=true&"
import script from "./ExamGroupShow.vue?vue&type=script&lang=ts&"
export * from "./ExamGroupShow.vue?vue&type=script&lang=ts&"
import style0 from "./ExamGroupShow.vue?vue&type=style&index=0&id=16980073&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16980073",
  null
  
)

export default component.exports